module.exports = __webpack_public_path__ + "imgs/circleYellow.edcd6.png";


//////////////////
// WEBPACK FOOTER
// ./circleYellow.png
// module id = WIgN
// module chunks = 0